import { Box, Button, TextField, Typography } from '@mui/material';
import { deserify } from '@geneo2-web/shared-ui';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLiveQuizContext } from '../../app/Context/LiveQuizContextProvider';
import { useAppSelector } from '../../reduxStore/reduxHooks';
import { LIVE_QUIZ_LOBBY } from '../../routeHandling/RoutesNomenclature';

// Manual/debug entry point, kept alongside the real one: the normal path is
// now choosing "Geneo Live Quiz" as the mode of conduction during assessment
// creation (AssementSelectionPopup → ConductionButtonsComponent), which lands
// on CongratulationsPage's "Go To Assessment" button already knowing the
// assessment id + section. This screen exists for starting a live quiz
// against an already-created assessment without recreating one.
export const LiveQuizStart = () => {
  const navigate = useNavigate();
  const { createLiveQuizSession } = useLiveQuizContext();
  const { user_info } = deserify(useAppSelector((state) => state.auth));
  const [assessmentId, setAssessmentId] = useState('');
  const [schoolClassSectionId, setSchoolClassSectionId] = useState('');
  const [loading, setLoading] = useState(false);

  const handleStart = async () => {
    if (!assessmentId || !schoolClassSectionId || !user_info?.teacherProfileId)
      return;
    if (!/^\d+$/.test(assessmentId) || !/^\d+$/.test(schoolClassSectionId)) {
      return;
    }
    setLoading(true);
    const session = await createLiveQuizSession({
      teacherId: user_info.teacherProfileId,
      assessmentId: BigInt(assessmentId),
      schoolClassSectionId: BigInt(schoolClassSectionId),
    });
    setLoading(false);
    if (session) {
      navigate(LIVE_QUIZ_LOBBY);
    }
  };

  return (
    <Box sx={{ p: 4, maxWidth: 480, mx: 'auto' }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Start a Live Quiz
      </Typography>
      <TextField
        fullWidth
        label="Assessment ID"
        value={assessmentId}
        onChange={(e) => setAssessmentId(e.target.value)}
        sx={{ mb: 2 }}
      />
      <TextField
        fullWidth
        label="Class Section ID"
        value={schoolClassSectionId}
        onChange={(e) => setSchoolClassSectionId(e.target.value)}
        sx={{ mb: 2 }}
      />
      <Button
        fullWidth
        variant="contained"
        disabled={loading || !assessmentId || !schoolClassSectionId}
        onClick={handleStart}
      >
        {loading ? 'Starting…' : 'Start Live Quiz'}
      </Button>
    </Box>
  );
};

export default LiveQuizStart;
